export function useMallarFetch() {
  return (path: string, options: RequestInit = {}): Promise<Response> => {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      ...(options.headers as Record<string, string>),
    }
    return fetch(`/mallar${path}`, { ...options, headers, credentials: 'include' })
  }
}
